(angular => {
  "use strict";

  angular.module("App").factory("ActivityService", [
    "$http",
    "API",
    "dateHelper",
    ActivityService
  ]);

  function ActivityService($http, API, dateHelper) {

    const list = () => {
      return $http.get(`${API}/activity`).then(result => result.data.map(d => dateHelper.parseObj(d)));
    };

    const updateRestrictedList = (activity) => {
      return $http.post(`${API}/activity/updateRestrictedList`, activity)
        .then(res => res.data);
    };


    return { list, updateRestrictedList };

  }

})(angular);
